export default __webpack_public_path__ + "f6ab0e7f548cbb5e27f9a823adb39fcc.svg";